export function normalizeErrorColorFieldName(fieldName: string): string {
  return fieldName.replaceAll(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    (substr, isMatch) => (isMatch ? '-' : '') + substr.toLowerCase(),
  )
}
